import { call, put } from 'redux-saga/effects';
import api from '@/services/api';

import ExperienceActions, { ExperienceTypes } from '@/store/ducks/experience';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import Toast from '@/utils/toast';
import { getAPIErrorPayload } from '@/utils/commonFunctions';

export function* getExperienceRequest() {
  try {
    const {
      API_URLS: { experience },
    } = GLOBAL_CONSTANTS;
    const { data } = yield call(api.get, experience);
    yield put(ExperienceActions.getExperienceSuccess(data?.data ?? []));
  } catch (error) {
    Toast.error(error?.message);
    yield put(ExperienceActions.getExperienceFailure(getAPIErrorPayload(ExperienceTypes.GET_EXPERIENCE_REQUEST, error)));
  }
}
